import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate,useSearchParams } from 'react-router-dom';
import { Users, Mail, Phone, Plus, Trash2, Loader2 } from 'lucide-react';
import DashboardLayout from './components/layout/Dashboardlayout';
import { Card, CardContent, CardHeader, CardTitle } from './components/ui/Card';
import { Button } from './components/ui/button';
import { Input } from './components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './components/ui/dialog';
import { useAuth } from './contexts/AuthContext';
//import { useBusiness } from './hooks/useBusiness';
//import { useLeads } from './hooks/useLeads';
import { supabase } from './integrations/supabase/client';
import { format } from 'date-fns';
import axios from 'axios';

const TonesMap = [
  { value: "auto", label: "Auto (Claude decides)" },
  { value: "aggressive", label: "Aggressive / Direct" },
  { value: "soft", label: "Soft / Relationship-first" },
  { value: "professional", label: "Professional / Formal" },
];

const StepsMap = [
  { value: "auto", label: "Auto (Claude decides)" },
  { value: "3", label: "3 steps (days 0, 3, 7)" },
  { value: "5", label: "5 steps (days 0, 3, 7, 14, 21)" },
  { value: "7", label: "7 steps (days 0, 3, 7, 14, 21, 30, 45)" },
];

const LEAD_STATUSES = [
  { value: 'new', label: 'New', color: { bg: 'rgba(99, 102, 241, 0.1)', text: '#6366f1' } },
  { value: 'contacted', label: 'Contacted', color: { bg: 'rgba(251, 146, 60, 0.1)', text: '#f59e0b' } },
  { value: 'follow_up', label: 'Follow Up', color: { bg: 'rgba(99, 102, 241, 0.1)', text: '#6366f1' } },
  { value: 'converted', label: 'Converted', color: { bg: 'rgba(34, 197, 94, 0.1)', text: '#22c55e' } },
  { value: 'lost', label: 'Lost', color: { bg: 'rgba(239, 68, 68, 0.1)', text: '#ef4444' } },
];

const LeadsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const businessId = searchParams.get('business');
  //const [business, setBusiness] = useState(null);
  const userId = location.state?.userId || null;
  //const { business, loading: businessLoading } = useBusiness();
  const [leads, setLeads] = useState([]);
  const [tone, setTone] = useState("auto");
  const [steps, setSteps] = useState("auto");
  const [abTesting, setAbTesting] = useState(true);
  const [objectionHandling, setObjectionHandling] = useState(true);
  const [perLeadPersonalization, setPerLeadPersonalization] = useState(true);
  const [dailyLimit, setDailyLimit] = useState(30);
  const [timezone, setTimezone] = useState("America/New_York");
  const [loading, setLoading] = useState(false);
  //const { leads, loading, fetchLeads, createLead, updateLeadStatus, deleteLead } = useLeads(business?.id);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [changes,setChanges]= useState({})
  const [newLead, setNewLead] = useState({ name: '', email: '', phone: '', source: 'website' });
  const [demoKey, setDemoKey] = useState("");

  const fetchLeads = async () => {
    //if (!businessId) return;

    setLoading(false);
    const data = {
      'owner_id' : userId,
      'businessId' : businessId
    }
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/leads`,{
          params: { user_id: userId, business_id: businessId, },
        });
      //if (error) throw error;

      setLeads(res.data || []);
      //console.log(res.data);
    } catch (err) {
      console.error('Error fetching leads:', err);
      //toast.error('Failed to load leads');
    } finally {
      setLoading(false);
    }
  };

const launchCampaign = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/launchcampaign`,
      {
        owner_id: userId,
        business_id: businessId,   
        tone,
        steps,
        ab_testing: abTesting,
        objection_handling: objectionHandling,
        per_lead_personalization: perLeadPersonalization,
        daily_limit: dailyLimit,
        timezone,
      },
      
      {
    headers: {
      'x-demo-key': demoKey,
    },
  }
    );

  } catch (error) {
    console.error(error);
  }
};

  //const updateLeadStatus = async (leadId, status) => {
    //try {
      //const { error } = await supabase
        //.from('leads')
        //.//update({ status })
       // .eq('id', leadId);

      //if (error) throw error;

      //setLeads((prev) =>
        //prev.map((lead) =>
         // lead.id === leadId ? { ...lead, status } : lead
       // )
      //);
    //} catch (err) {
      //console.error('Error updating lead:', err);
   // }
  //};

  const updateLeadStatus = async (leadId, status) => {
    try {
        await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/leads/${leadId}`, { status })
        setLeads(prev => prev.map(lead => lead.id === leadId ? { ...lead, status } : lead));
    } catch (err) {
        console.error('Error updating lead:', err);
    }
};

const deleteLead = async (leadId) => {
    try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/leads/${leadId}`)
        setLeads(prev => prev.filter(lead => lead.id !== leadId));
    } catch (err) {
        console.error('Error deleting lead:', err);
    }
};

  //const deleteLead = async (leadId) => {
    //try {
     // const { error } = await supabase
       // .from('leads')
       // .delete()
       // .eq('id', leadId);

      //if (error) throw error;

      //setLeads((prev) => prev.filter((lead) => lead.id !== leadId));
      //toast.success('Lead deleted');
    //} catch (err) {
      //console.error('Error deleting lead:', err);
      //toast.error('Failed to delete lead');
    //}
  //};

  useEffect(() => {
    if (businessId) {
      fetchLeads();
    }
  }, [businessId]);



  const getStatusStyle = (status) => {
    const statusConfig = LEAD_STATUSES.find(s => s.value === status);
    return statusConfig ? statusConfig.color : { bg: '#f3f4f6', text: '#9ca3af' };
  };

  // Safe leads array with null check
  const safeLeads = Array.isArray(leads) ? leads : [];

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '16px'
    },
    headerText: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    title: {
      fontSize: '30px',
      fontWeight: 'bold',
      margin: 0
    },
    subtitle: {
      color: '#9ca3af',
      fontSize: '14px',
      margin: 0
    },
    addButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 20px',
      borderRadius: '8px',
      border: 'none',
      background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s'
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
      gap: '16px'
    },
    statCard: {
      padding: '16px',
      textAlign: 'center'
    },
    statNumber: {
      fontSize: '24px',
      fontWeight: 'bold',
      margin: 0,
      marginBottom: '4px'
    },
    statLabel: {
      fontSize: '14px',
      color: '#9ca3af',
      margin: 0
    },
    tableContainer: {
      overflowX: 'auto',
      width: '100%'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    tableHeader: {
      borderBottom: '1px solid #e5e7eb'
    },
    th: {
      textAlign: 'left',
      padding: '12px 16px',
      fontWeight: '500',
      color: '#9ca3af',
      fontSize: '14px'
    },
    thRight: {
      textAlign: 'right',
      padding: '12px 16px',
      fontWeight: '500',
      color: '#9ca3af',
      fontSize: '14px'
    },
    tableRow: {
      borderBottom: '1px solid #e5e7eb',
      transition: 'background-color 0.2s'
    },
    td: {
      padding: '12px 16px',
      fontSize: '14px'
    },
    tdRight: {
      padding: '12px 16px',
      textAlign: 'right'
    },
    contactContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    contactLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      color: '#9ca3af',
      textDecoration: 'none',
      transition: 'color 0.2s'
    },
    statusSelect: (status) => {
      const style = getStatusStyle(status);
      return {
        padding: '4px 12px',
        borderRadius: '9999px',
        fontSize: '12px',
        fontWeight: '500',
        border: 'none',
        cursor: 'pointer',
        background: style.bg,
        color: style.text
      };
    },
    emptyState: {
      textAlign: 'center',
      padding: '32px 0',
      color: '#9ca3af'
    },
    emptyIcon: {
      width: '48px',
      height: '48px',
      margin: '0 auto 12px',
      opacity: 0.5
    },
    deleteButton: {
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      borderRadius: '6px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 0.2s'
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    label: {
      fontSize: '14px',
      fontWeight: '500'
    },
    input: {
      width: '100%',
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      fontSize: '14px',
      background: '#ffffff',
      outline: 'none',
      transition: 'border-color 0.2s'
    },
    select: {
      width: '100%',
      height: '44px',
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      fontSize: '14px',
      background: '#ffffff',
      outline: 'none',
      cursor: 'pointer'
    },
    submitButton: {
      width: '100%',
      padding: '10px 16px',
      borderRadius: '8px',
      border: 'none',
      background: '#6366f1',
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    loader: {
      display: 'flex',
      justifyContent: 'center',
      padding: '32px 0'
    }
  };

  return (
    <DashboardLayout>
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.headerText}>
            <h1 style={styles.title}>Lead Management</h1>
            <p style={styles.subtitle}>Track and manage your leads</p>
          </div>
          
          <Dialog open={isAddOpen} onOpenChange={setIsAddOpen}>
            <DialogTrigger asChild>
              <button style={styles.addButton}>
                <Plus style={{ width: '20px', height: '20px' }} />
                Launch Campaign
              </button>
            </DialogTrigger>

  <DialogContent style={{ maxWidth: 520, maxHeight: '85vh', overflowY: 'auto' }}>
    <DialogHeader>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20, marginTop: 8 }}>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <label style={styles.label}>Demo Key</label>
                    <input
                      type="text"
                      value={demoKey}
                      onChange={(e) => setDemoKey(e.target.value)}
                      style={styles.input}
                      placeholder="Enter your demo key"
                    />
                  </div>

      {/* ── Tone ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={styles.label}>Tone</label>
        <select value={tone} onChange={e => setTone(e.target.value)} style={styles.select}>
          {TonesMap.map(s => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
      </div>
       {/* ── Steps override ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={styles.label}>Steps override</label>
        <select value={steps} onChange={e => setSteps(e.target.value)} style={styles.select}>
          {StepsMap.map(s => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
      </div>

      {/* ── Daily limit ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={styles.label}>Daily email limit</label>
        <input
          type="number"
          min={1}
          max={200}
          value={dailyLimit}
          onChange={e => setDailyLimit(Number(e.target.value))}
          style={styles.input}
        />
      </div>

      {/* ── Timezone ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={styles.label}>Send timezone</label>
        <select value={timezone} onChange={e => setTimezone(e.target.value)} style={styles.select}>
          <option value="America/New_York">Eastern (New York)</option>
          <option value="America/Chicago">Central (Chicago)</option>
          <option value="America/Denver">Mountain (Denver)</option>
          <option value="America/Los_Angeles">Pacific (Los Angeles)</option>
          <option value="Europe/London">London</option>
          <option value="Europe/Berlin">Berlin</option>
        </select>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, paddingTop: 4 }}>
        <label style={styles.label}>Features</label>

        {[
          { label: 'Lead scoring & segmentation', state: true, disabled: true, note: 'Always on' },
          { label: 'A/B subject line variants',   value: abTesting,              setter: setAbTesting },
          { label: 'Objection handling emails',   value: objectionHandling,      setter: setObjectionHandling },
          { label: 'Per-lead personalization',    value: perLeadPersonalization, setter: setPerLeadPersonalization },
        ].map(({ label, value, setter, disabled, note }) => (
          <div key={label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 14, color: disabled ? styles.label.color : 'inherit' }}>
              {label}
              {note && <span style={{ fontSize: 12, color: styles.label.color, marginLeft: 6 }}>({note})</span>}
            </span>
            <input
              type="checkbox"
              checked={disabled ? true : value}
              disabled={disabled}
              onChange={disabled ? undefined : e => setter(e.target.checked)}
              style={{ width: 16, height: 16, cursor: disabled ? 'default' : 'pointer' }}
            />
          </div>
        ))}
      </div>
      
                    <button
                    onClick={launchCampaign}
                    style={{
                      marginBottom: "10px",
                      padding: "8px 14px",
                      borderRadius: "6px",
                      border: "none",
                      backgroundColor: "#10b981",
                      color: "white",
                      cursor: "pointer",
                      }}
                      >
                            LaunchCampaigns
                    </button>
      </div>
      <DialogTitle>Launch Campaigns</DialogTitle>
    </DialogHeader>
    </DialogContent>
          </Dialog>

        </div>

        {/* Stats */}
        <div style={styles.statsGrid}>
          {LEAD_STATUSES.map((status) => {
            const count = safeLeads.filter(l => l?.status === status.value).length;
            return (
              <Card key={status.value}>
                <CardContent style={styles.statCard}>
                  <p style={styles.statNumber}>{count}</p>
                  <p style={styles.statLabel}>{status.label}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Leads Table */}
        <Card>
          <CardHeader>
            <CardTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Users style={{ width: '20px', height: '20px' }} />
              All Leads ({safeLeads.length})
            </CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div style={styles.loader}>
                <Loader2 style={{
                  width: '24px',
                  height: '24px',
                  animation: 'spin 1s linear infinite',
                  color: '#9ca3af'
                }} />
              </div>
            ) : safeLeads.length > 0 ? (
              <div style={styles.tableContainer}>
                
                <table style={styles.table}>
                  <thead style={styles.tableHeader}>
                    <tr>
                      <th style={styles.th}>Name</th>
                      <th style={styles.th}>Company Name</th>
                      <th style={styles.th}>company_domain</th>
                      <th style={styles.th}>Status</th>
                      <th style={styles.th}>email</th>
                      <th style={styles.thRight}>location</th>
                      <th style={styles.thRight}>Update Status</th>
                      <th style={styles.thRight}>Delete Lead</th>
                    </tr>
                  </thead>
                  <tbody>

                    {safeLeads.map((lead) => {
                      if (!lead || !lead.id) return null;
                      
                      return (
                        <tr 
                          key={lead.id} 
                          style={styles.tableRow}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(243, 244, 246, 0.5)'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                          <td style={{ ...styles.td, fontWeight: '500' }}>
                            {lead.full_name || 'Unknown'}
                          </td>
                          <td style={{ ...styles.td, textTransform: 'capitalize' }}>
                            {lead.company_name ? lead.company_name.replace('_', ' ') : 'Unknown'}
                          </td>
                          
                          <td style={{ ...styles.td, textTransform: 'capitalize' }}>
                            {lead.company_domain ? lead.company_domain.replace('_', ' ') : 'Unknown'}
                          </td>

                          <td style={styles.td}>
                            <select
                              value={changes[lead.id] ?? lead.status ?? ''}
                              onChange={(e) => setChanges(prev=> ({...prev,[lead.id]: e.target.value}))}
                              style={styles.statusSelect(lead.status)}
                            >
                              {LEAD_STATUSES.map((s) => (
                                <option key={s.value} value={s.value}>{s.label}</option>
                              ))}
                            </select>
                          </td>
                          
                          
                          <td style={{ ...styles.td, textTransform: 'capitalize' }}>
                            {lead.email ? lead.email.replace('_', ' ') : 'Unknown'}
                          </td>
                          
                          <td style={{ ...styles.td, textTransform: 'capitalize' }}>
                            {lead.location ? lead.location.replace('_', ' ') : 'Unknown'}
                          </td>
                          
                          <td style={{ ...styles.td, color: '#9ca3af' }}>
                            <button
                              style={styles.deleteButton}
                              onClick={() => updateLeadStatus(lead.id,changes[lead.id])}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                            </button>
                          </td>
                          <td style={styles.tdRight}>
                            <button
                              style={styles.deleteButton}
                              onClick={() => deleteLead(lead.id)}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                              <Trash2 style={{ width: '16px', height: '16px', color: '#ef4444' }} />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={styles.emptyState}>
                <Users style={styles.emptyIcon} />
                <p style={{ margin: '0 0 8px 0' }}>No leads yet</p>
                <button
                  onClick={() => setIsAddOpen(true)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#6366f1',
                    cursor: 'pointer',
                    fontSize: '14px',
                    padding: '8px',
                    textDecoration: 'underline'
                  }}
                >
                  Add your first lead
                </button>
              </div>
            )}
          </CardContent>
        </Card>
      </div>

      <style>
        {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </DashboardLayout>
  );
};

export default LeadsPage;
